"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSystemPayReservationComment = void 0;
function formatSystemPayReservationComment(transactionId, cardBrand) {
    const tx = `Transaction ${transactionId}`;
    const brand = (cardBrand !== null && cardBrand !== void 0 ? cardBrand : '').toUpperCase();
    if (brand === 'APPLE_PAY' || brand === 'APPLEPAY') {
        return `Moyen de paiement : Apple Pay (SystemPay), ${tx}`;
    }
    if (brand === 'GOOGLEPAY') {
        return `Moyen de paiement : Google Pay (SystemPay), ${tx}`;
    }
    if (brand === 'PAYPAL' || brand === 'PAYPAL_SB') {
        return `Moyen de paiement : PayPal (SystemPay), ${tx}`;
    }
    return `Moyen de paiement : Carte bancaire (SystemPay), ${tx}`;
}
exports.formatSystemPayReservationComment = formatSystemPayReservationComment;
//# sourceMappingURL=systempayLabels.js.map